export const BACK_TO_SCHOOL_BADGE = 'Back To School';

export function selectPromotionBadge({
    backToSchoolActive = false,
    categories = [],
    backToSchoolEligible,
    backToSchoolTitle = BACK_TO_SCHOOL_BADGE,
    backToSchoolCategory = BACK_TO_SCHOOL_BADGE,
    lensCreditTitle = null,
    fallback = null,
} = {}) {
    const isBackToSchoolStyle = typeof backToSchoolEligible === 'boolean'
        ? backToSchoolEligible
        : Array.isArray(categories) && categories.includes(backToSchoolCategory);

    if (backToSchoolActive && isBackToSchoolStyle) {
        return backToSchoolTitle;
    }

    // A lens credit is a concrete dollar promo, so it outranks a generic sale badge
    if (lensCreditTitle) {
        return lensCreditTitle;
    }

    return fallback;
}
